import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Router } from '@angular/router';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/catch';
import { tap } from 'rxjs/operators';
import { Media, NGXLogger, Decoration } from '@app/shared';
import { MediaService } from '@app/core';
import {
  MediaActionTypes,
  GetMedias,
  GetMediasSuccess,
  GetMediasFailure,

  GetDecorations,
  GetDecorationsSuccess,
  GetDecorationsFailure,

  SetMedia,
  SetMediaSuccess,
  SetMediaFailure,

} from '../actions/media.actions';


@Injectable()
export class MediaEffects {

  constructor(
    private actions: Actions,
    private mediaService: MediaService,
    private router: Router,
    private logger:NGXLogger
  ) {

  }

    @Effect()
    GetMedias: Observable<any> = this.actions
        .ofType(MediaActionTypes.GET_MEDIAS)
        .debounceTime(200)
        .map((action: GetMedias) => action.payload)
        .switchMap(payload => {
          return this.mediaService.getMedias(payload.searchCriteria.keyword,payload.searchCriteria.includeAssets)
            .map((result) => {

              let prods = [];
              // init media members
              result.data.map(media => {
                let prod = Object.assign( new Media(), media );
                let arr = [];
                if(prod.mediaassets){
                  prod.mediaassets.map(asset => {

                      if(asset.media){
                        let val:Media = Object.assign( new Media(), asset.media );
                        arr.push(val);
                      }

                    }
                  )
                  prod.mediaassets = arr;
                }

                prods.push(prod);
              });

              return new GetMediasSuccess({medias:prods,searchCriteria:payload.searchCriteria})
            })
            .catch((error) => {
              this.logger.debug(error);
              return Observable.of(new GetMediasFailure({ error: error }));
            });
        })



    @Effect({ dispatch: false })
    GetMediasSuccess: Observable<any> = this.actions.pipe(
      ofType(MediaActionTypes.GET_MEDIAS_SUCCESS),
      tap((result) => {
        this.logger.debug(result, ' in tap')
      })
    );

    @Effect({ dispatch: false })
    GetMediasFailure: Observable<any> = this.actions.pipe(
      ofType(MediaActionTypes.GET_MEDIAS_FAILURE)
    );


    @Effect()
    GetDecorations: Observable<any> = this.actions
        .ofType(MediaActionTypes.GET_DECORATIONS)
        .debounceTime(200)
        .map((action: GetMedias) => action.payload)
        .switchMap(payload => {
          return this.mediaService.getDecorations(payload.searchCriteria.keyword,payload.searchCriteria.includeAssets)
            .map((result) => {

              let decs = [];
              // init media members
              result.data.map(decoration => {
                let dec = Object.assign( new Decoration(), decoration );
                decs.push(dec);
              });

              return new GetDecorationsSuccess({decorations:decs,searchCriteria:payload.searchCriteria})
            })
            .catch((error) => {
              this.logger.debug(error);
              return Observable.of(new GetDecorationsFailure({ error: error }));
            });
        })

    @Effect({ dispatch: false })
    GetDecorationsSuccess: Observable<any> = this.actions.pipe(
      ofType(MediaActionTypes.GET_DECORATIONS_SUCCESS),
      tap((result) => {
        this.logger.debug(result, ' in tap')
      })
    );

    @Effect({ dispatch: false })
    GetDecorationsFailure: Observable<any> = this.actions.pipe(
      ofType(MediaActionTypes.GET_DECORATIONS_FAILURE)
    );

    // SETTING CURRENT Media
    @Effect()
    /*SetMedia: Observable<any> = this.actions
        .ofType(MediaActionTypes.SET_MEDIA)
        .map((action: GetMedias) => action.payload)
        .switchMap(payload => {
          return this.mediaService.getMedia(payload.media)
            .map((result) => {
              this.logger.debug(result.data);
              //return new LogInSuccess({token: user.token, email: payload.email});
              return new SetMediaSuccess({selectedMedia:payload.media})
            })
            .catch((error) => {
              this.logger.debug(error);
              return Observable.of(new SetMediaFailure({ error: error }));
            });
        });*/


    @Effect({ dispatch: false })
    SetMediaSuccess: Observable<any> = this.actions.pipe(
      ofType(MediaActionTypes.SET_MEDIA_SUCCESS),
      tap((result) => {

        this.logger.debug(result)
        // localStorage.setItem('token', user.payload.token);
        // this.router.navigateByUrl('/main');
      })
    );

    @Effect({ dispatch: false })
    SetMediaFailure: Observable<any> = this.actions.pipe(
      ofType(MediaActionTypes.SET_MEDIA_FAILURE)
    );
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/store/effects/media.effects.ts